"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const data_storage_1 = require("@studyportals/data-storage");
const CountryTestResults_1 = require("@/classes/CountryTestResults");
const Tracker_1 = require("@/classes/Tracker");
const portal_types_1 = require("@/enums/portal-types");
const store_1 = __importDefault(require("@/store"));
const state_1 = __importDefault(require("@/store/state"));
const ANSWERS_STORAGE_LABEL = "CountryTestAnswers";
const actions = {
    setPreferredPortal: (preferredPortalType) => {
        store_1.default.mutations.setPreferredPortal(preferredPortalType);
    },
    setOriginPortal: () => {
        let portal = window.location.host;
        let portalType = portal_types_1.PortalType.MASTERS;
        switch (true) {
            case (portal.indexOf('mastersportal.com') !== -1):
                portalType = portal_types_1.PortalType.MASTERS;
                break;
            case (portal.indexOf('bachelorsportal.com') !== -1):
                portalType = portal_types_1.PortalType.BACHELORS;
                break;
            case (portal.indexOf('phdportal.com') !== -1):
                portalType = portal_types_1.PortalType.PHD;
                break;
            case (portal.indexOf('distancelearningportal.com') !== -1):
                portalType = portal_types_1.PortalType.DISTANCE_LEARNING;
                break;
            case (portal.indexOf('shortcoursesportal.com') !== -1):
                portalType = portal_types_1.PortalType.SHORT_COURSES;
                break;
            case (portal.indexOf('preparationcoursesportal.com') !== -1):
                portalType = portal_types_1.PortalType.PREPARATION_COURSES;
                break;
        }
        store_1.default.mutations.setOriginPortal(portalType);
    },
    answerQuestion: (answerObject) => {
        store_1.default.mutations.answerQuestion(answerObject);
        actions.copyAnswersToLocalStorage({}, state_1.default.questions);
    },
    copyAnswersToLocalStorage: ({}, answers) => {
        data_storage_1.DataStorage.store(ANSWERS_STORAGE_LABEL, JSON.stringify(answers), 60 * 60 * 24);
    },
    storeResults: () => __awaiter(void 0, void 0, void 0, function* () {
        const session = yield window.SessionService.getSession();
        const data = {
            identityId: session.getUser().identityId,
            testType: "CountryTest",
            answers: state_1.default.questions.map(question => ({
                question: question.type,
                answer: question.answer.toString()
            })),
            result: state_1.default.results.slice(0, 4).map(country => country.id)
        };
        try {
            const response = yield fetch(`${TEST_RESULT_API_URL}results`, {
                method: 'POST',
                body: JSON.stringify(data)
            });
            const responseBody = yield response.json();
            if (!response.ok || responseBody.failed) {
                throw new Error("Storing results failed.");
            }
        }
        catch (error) {
            console.error(`Storing results failed: ${error}`);
        }
    }),
    getResults: () => {
        store_1.default.mutations.storeResults(CountryTestResults_1.CountryTestResults.getResults(store_1.default.getters.questions()));
        // For each of the top 4 countries that are shown, track the following:
        for (let i = 0; i < 4 && i < state_1.default.results.length; i++) {
            const result = state_1.default.results[i];
            Tracker_1.CountryTestTracker.fireTracking('results_country', 
            // The country id.
            result.id.toString(), 
            // The position of the suggested country (1, 2, 3 or 4).
            (i + 1).toString(), 
            // The score of the country that allowed it to appear as one of the top ones.
            result.bonus);
        }
        actions.storeResults();
    },
    retrieveStoredAnswers: () => {
        const answers = data_storage_1.DataStorage.retrieve(ANSWERS_STORAGE_LABEL);
        if (!answers || !answers.length) {
            return;
        }
        state_1.default.questions = JSON.parse(answers);
    }
};
exports.default = actions;
